import Container from "./containers/Container";

const CheckDocuments = {
    Container
}

export {CheckDocuments}